var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.number || _vm.number == 0)?_c('div',{staticClass:"h-full rounded-xl flex flex-col justify-center items-center",class:_vm.boxClass},[_c('p',{staticClass:"text-gray-100 mb-0 font-medium text-subheading"},[_vm._v(_vm._s(_vm.content))]),_c('p',{staticClass:"text-heading-main font-bold text-gray-100 mb-0"},[_vm._v(_vm._s(_vm.number))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }